<template>
  <b-container fluid class="content-box-blue">
    <div class="header__bg_blue"></div>
    <b-container class="margin-box">
      <b-row class="content-section">
        <b-col cols="12" md="6" class="content-area" v-animate-onscroll="'animated zoomIn'">
          <h2 :id="'header-section-' + content.content_id" v-html="content.content_title"></h2>
          <div :id="'content-section-' + content.content_id" v-html="content.content_description"></div>
          <div class="header-button">
            <b-button @click="$router.push('/' + $store.state.selectlanguage + link)" class="btn-magenta">{{
              $store.state.labels.BTN_SEE_PRODUCT }}</b-button>
            &nbsp;
            <b-button @click="contactSales($store.state.configs.brand_email)" class="btn-transparent btn-noborder">{{
              $store.state.labels.BTN_CONTACT_SALES }}</b-button>
          </div>
        </b-col>
        <b-col cols="12" md="6" class="content-area" v-animate-onscroll="'animated zoomIn'">
          <b-img-lazy v-bind="contentProps" :src="content.content_image" :alt="content.content_title"
            class="img-max-width"></b-img-lazy>
        </b-col>
      </b-row>
    </b-container>
  </b-container>
</template>

<script>
export default {
  name: 'ContentBoxBlue',
  props: {
    content: { type: Object, required: true, default: null },
    link: { type: String, required: true, default: null },
  },
  data() {
    return {
      contentProps: {
        center: true,
        fluidGrow: true,
        blank: true,
        blankColor: "#bbb",
        class: "p-20",
      },
    }
  },
  methods: {
    contactSales(email) {
      window.location = "mailto:" + email;
    },
  },
}
</script>

